import { Form } from "antd"
import { notification } from "components/common"
import {
  useEditMortgageAssessmentMutation,
  useAddMortgageAssessmentMutation,
  useShareLeadWithMortgageTeamMutation,
} from "features/leads/api"
import { forwardRef, useRef } from "react"
import { useTranslation } from "react-i18next"
import MortgageAssessmentCalculator from "./mortgageCalculator"
import ShareLeadWithMortgage from "./shareLeadWithMortgage"

const ShareWithMortgage = forwardRef(({ lead }, ref) => {
  const { t } = useTranslation()

  const mortgageSharingRef = useRef()

  const [calculatorForm] = Form.useForm()
  const [shareLeadForm] = Form.useForm()

  const [shareLeadWithMortgageTeam, { data, isLoading, error }] = useShareLeadWithMortgageTeamMutation()
  const [mortgageAssessment, { data: mortgageAssessmentData, isLoading: isMortgageAssessmentLoading, reset }] =
    useAddMortgageAssessmentMutation()
  const [
    editMortgageAssessment,
    { data: editedMortgageAssessmentData, isLoading: editMortgageAssessmentLoading, reset: editMortgageReset },
  ] = useEditMortgageAssessmentMutation()

  const onShareLead = values => {
    const calculator = calculatorForm.getFieldsValue()
    const shareLead = shareLeadForm.getFieldsValue()

    shareLeadWithMortgageTeam({ ...values, ...calculator, ...shareLead, lead })
      .unwrap()
      .then(() => {
        calculatorForm.resetFields()
        shareLeadForm.resetFields()
        mortgageSharingRef.current?.setVisible(false)
        notification.success({ message: t("Lead has been successfully shared") })
      })
      .catch(err => {
        notification.error({ message: err?.message || err?.data?.[0]?.message })
      })
  }

  const openAttachmentModal = () => {
    calculatorForm?.validateFields().then(values => {
      ref?.current?.setVisible(false)
      mortgageSharingRef?.current?.setVisible(true)
    })
  }

  const resetAll = () => {
    reset()
    calculatorForm?.resetFields()
    shareLeadForm?.resetFields()
    mortgageSharingRef?.current?.setVisible(false)
    ref?.current?.setVisible(false)
  }

  const shareLeadBackButtonClick = () => {
    mortgageSharingRef?.current?.setVisible(false)
    ref?.current?.setVisible(true)
  }

  const resetMutation = () => {
    editMortgageReset()
    reset()
  }
  return (
    <>
      <MortgageAssessmentCalculator
        form={calculatorForm}
        onShare={openAttachmentModal}
        ref={ref}
        addMortgageAssessment={mortgageAssessment}
        editMortgageAssessment={editMortgageAssessment}
        isLoading={isMortgageAssessmentLoading || editMortgageAssessmentLoading}
        mortgageAssessmentData={editedMortgageAssessmentData ? editedMortgageAssessmentData : mortgageAssessmentData}
        resetMutation={resetMutation}
        lead={lead?.[0]}
        resetAll={resetAll}
      />
      <ShareLeadWithMortgage
        form={shareLeadForm}
        onOk={onShareLead}
        ref={mortgageSharingRef}
        resetAll={resetAll}
        onClickBack={shareLeadBackButtonClick}
        loading={isLoading}
        leadId={lead?.[0]?.id}
      />
    </>
  )
})

export default ShareWithMortgage
